import { Box, CardMedia, IconButton, Skeleton } from "@mui/material";

import CommentSkeleton from "@/fragments/CommentSkeleton";
import SpotifyIcon from "@/fragments/SpotifyIcon";
import TikTokIcon from "@/fragments/TikTokIcon";

import { Edit, Instagram, Spotify } from "@mui/icons-material";

import CoverDefault from "@/assets/cover-default.jpg";

import { currentUser } from "@/App";

export default function ArtistHeader({ artist }) {
  const preventLongPressMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const getInstagramLink = () => {
    if (artist?.meta?.instagram?.includes("instagram.com")) {
      return artist?.meta?.instagram;
    }
    return `https://www.instagram.com/${artist?.meta?.instagram}`;
  };

  return (
    <>
      {!artist ? (
        <>
          <Skeleton variant="rectangular" width="100%" height={400} />
          <Box sx={{ my: 4, px: 2 }}>
            <CommentSkeleton />
            <CommentSkeleton />
            <CommentSkeleton />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            position: "relative",
            display: "inline-block",
            // maxHeight: "50vh",
            overflow: "hidden",
          }}
        >
          <CardMedia
            component="img"
            sx={{
              width: "100%", // Full width
              objectFit: "cover", // Maintains aspect ratio while covering the container
              backgroundPosition: "center",
              aspectRatio: "1 / 1",
            }}
            image={artist.meta?.cover || CoverDefault}
            onContextMenu={preventLongPressMenu}
            onTouchStart={preventLongPressMenu}
            onTouchEnd={preventLongPressMenu}
            onTouchMove={preventLongPressMenu}
            onMouseDown={preventLongPressMenu}
          />

          {currentUser.key === artist.key && (
            <IconButton
              sx={{
                position: "absolute",
                bottom: 8,
                left: 8,
                opacity: 0.8,
                zIndex: 1000,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
              onClick={() => (window.location.href = "/account")}
            >
              <Edit />
            </IconButton>
          )}

          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%", // Spans entire width
              px: 2,
              pb: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Box id="icon-links">
              {artist?.meta.instagram && (
                <IconButton
                  component="a"
                  href={getInstagramLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "5px" }}
                >
                  <Instagram />
                </IconButton>
              )}

              {artist?.meta.spotify && (
                <IconButton
                  component="a"
                  href={artist?.meta.spotify}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginRight: "5px" }}
                >
                  <SpotifyIcon />
                </IconButton>
              )}

              {artist?.meta.tiktok && (
                <IconButton
                  component="a"
                  href={artist?.meta.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TikTokIcon size={28} />
                </IconButton>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}
